// extracted by mini-css-extract-plugin
export default {"wrapper":"_611e156a"};